// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mbdE","newExpiryDate":"styles_newExpiryDate__3wRFg","footer":"styles_footer__3hyVX"};